import React, { Component } from 'react';
import { withRouter } from '../navigation/withNavigation';
import '../../assets/styles/draft.css';

function generateGuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Public landing page for a shared chapter link, e.g.
 *   /<project-slug>/chapter-<n>/share/<shareToken>
 *
 * Each visit spawns a FRESH onboarding draft (its own guid) populated from
 * the shared source chapter, then redirects to the standard onboarding writer
 * URL. This guarantees that visitors don't all collaborate on the same draft.
 */
class ShareableChapterWriterPage extends Component {
  state = { error: null };

  async componentDidMount() {
    await this.spawnDraft();
  }

  async spawnDraft() {
    const { navigate, params } = this.props;
    const shareToken = params?.guid; // route param is named :guid for back-compat

    if (!shareToken) {
      this.setState({ error: 'Missing share token. This link may be invalid.' });
      return;
    }

    if (this.inFlight) return;
    this.inFlight = true;

    const newGuid = generateGuid();

    try {
      const res = await fetch(`/api/v1/core/chapters/share/${shareToken}/spawn`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ guid: newGuid }),
      });

      if (res.status === 404) {
        this.setState({ error: 'This shared chapter is no longer available.' });
        return;
      }
      if (!res.ok) {
        throw new Error(`Failed to start session (${res.status})`);
      }

      const draft = await res.json();
      const targetGuid = draft?.guid || newGuid;
      navigate(`/on-boarding/${targetGuid}/writer`, { replace: true });
    } catch (err) {
      this.setState({ error: err?.message || 'Failed to start session.' });
    } finally {
      this.inFlight = false;
    }
  }

  render() {
    const { error } = this.state;

    if (error) {
      return (
        <div className="error-container">
          <h2>Unavailable</h2>
          <p>{error}</p>
          <button onClick={() => (window.location.href = '/')}>Back to Home</button>
        </div>
      );
    }

    return (
      <div className="loading-container">
        <p>Preparing your copy of the chapter…</p>
      </div>
    );
  }
}

export default withRouter(ShareableChapterWriterPage);
